import { graphql } from "babel-plugin-relay/macro";

export const addReportedIssueQL = graphql`
  mutation addReportedIssueMutation($sCardId: ID!, $sBackId: ID, $langBack: String, $reasons: [String!]!) {
    addReportedIssue(sCardId: $sCardId, sBackId: $sBackId, langBack: $langBack, reasons: $reasons)
  }
`;
